import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { StepPath } from './usePersonalDetailsRoutes'

const PERSONAL_DETAILS_STEPS: readonly StepPath[] = [
  'basic',
  'residence',
  'contact',
  'info',
  'password',
  'documents',
]
export const usePersonalDetailsGoBack = (
  stepPaths: readonly StepPath[] = PERSONAL_DETAILS_STEPS
) => {
  const navigate = useNavigate()
  const location = useLocation()
  const PERSONAL_DETAILS_BASE = '/sign-up/personal-details'

  return useCallback(() => {
    const pathParts = location.pathname.split('/').filter(Boolean)

    const currentStep = [...pathParts]
      .reverse()
      .find((part): part is StepPath => stepPaths.includes(part as StepPath))

    const currentIndex = currentStep ? stepPaths.indexOf(currentStep) : -1
    const previousStep = currentIndex > 0 ? stepPaths[currentIndex - 1] : undefined

    if (!previousStep) {
      navigate(`/sign-up${location.search}`, {
        state: { keepValues: true },
      })
      return
    }

    navigate(`${PERSONAL_DETAILS_BASE}/${previousStep}${location.search}`)
  }, [navigate, location.pathname, location.search, stepPaths])
}
